<template>
  <div class="poster-actions">
    <div
      v-if="removeAction"
      :data-wptv="removeAction.dataWptv"
      class="action-btn"
      @click.prevent="removeAction.onClick">
      <wptv-icon
        :title="removeAction.label"
        name="trash"
        width="1em"
        height="1em" />
    </div>
  </div>
</template>

<script>
import WptvPosterConfig from '../poster.config'
import { WptvIcon } from '../../icon'

export default {
  name: 'PosterActions',
  components: {
    WptvIcon
  },
  props: {
    actions: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      ACTIONS: WptvPosterConfig.ACTIONS
    }
  },
  computed: {
    removeAction () {
      return this.actions.find(action => action.name === this.ACTIONS.REMOVE)
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../../scss/abstracts/variables';
@import '../../../scss/abstracts/mixins';

.poster-actions {
  position: absolute;
  z-index: 3;
  @include mediaQueries('top', (xsmall: 84%));
  @include mediaQueries('left', (xsmall: 76%));

  .action-btn {
    position: relative;
    border-radius: 20px;
    background: rgba(255, 255, 255, calc(0.6 / 0.8));
    @include mediaQueries('height', (xsmall: 25px, medium: 30px, large: 25px, xlarge: 30px));
    @include mediaQueries('width', (xsmall: 25px, medium: 30px, large: 25px, xlarge: 30px));

    img {
      @include mediaQueries('margin', (xsmall: 5px, xlarge: 4px));

      &.wptv-icon {
        @include mediaQueries('font-size', (xsmall: 18px, medium: 22px, large:18px, xlarge: 24px));
      }
    }

    &:hover  {
      filter: invert(1);
    }

  }
}
</style>
